<div class="icon-input-container">
  <bringoz-icon *ngIf="!query" iconName="search-outline" fill="#7E7E7E" class="input-icon left"></bringoz-icon>
  <bringoz-icon *ngIf="query" iconName="close" (click)="clear()" fill="#7E7E7E" class="input-icon left"></bringoz-icon>
  <input type="text"
         class="form-control input"
         #searchInput
         [placeholder]="(placeholder || 'Search') | translate"
         [disabled]="isDisabled">
</div>
